import angular from 'angular';

import { arrayPrototypeMutations } from './Array';
import { JSONObjectMutations } from './JSON';
import { objectMethodMutations } from './Object';
import { stringPrototypeMutations } from './String';

/**
 * @ngdoc    overview
 * @name     csm.polyfill
 * @description
 * Modifies the native Javascript environment to add Polyfills.
 *
 * ! UPDATE
 * TODO PK
 * The above description is a lie because there is nothing here being
 * polyfilled. What is happening here is that new custom methods that
 * were invented are being added to the prototype of built in JS classes.
 *
 * This is a bad practice to do this and needs to be removed. PK
 **/
// export default angular.module('csm.polyfill', []).run(function () {
//   arrayPrototypeMutations();
//   JSONObjectMutations();
//   objectMethodMutations();
//   stringPrototypeMutations();
// }).name;
export default angular
  .module('csm.polyfill', [])
  .run(arrayPrototypeMutations)
  .run(JSONObjectMutations)
  .run(objectMethodMutations)
  .run(stringPrototypeMutations)
  .name;